__turbopack_context__.v({
  "electricityConsumptionCalculator": "mbvw0G_electricityConsumptionCalculator",
  "electricityConsumptionCalculatorForm": "mbvw0G_electricityConsumptionCalculatorForm",
  "formField": "mbvw0G_formField",
  "heading": "mbvw0G_heading",
  "toggleButton": "mbvw0G_toggleButton",
  "toggleButtonSelected": "mbvw0G_toggleButtonSelected",
  "toggleButtons": "mbvw0G_toggleButtons",
});
